module.exports = __webpack_public_path__ + "media/packs/images/flags/CH-64ac1ae5b74fd4f1df0c63298e970e79.svg";